import { Model } from "@vuex-orm/core";

export default class SubscriptionType extends Model {
  static entity = "subscriptionTypes";

  static fields() {
    return {
      id: this.attr(),
      name: this.attr()
    };
  }
}
